import { h, on } from './dom.js';

/**
 * Filter chip — selectable pill-shaped button.
 *   <Chip label="SNES" active onClick={...} />
 */
export function Chip({ label, active = false, onClick, count }) {
  const el = h('button', {
    type: 'button',
    class: `lib-chip${active ? ' active' : ''}`,
    'aria-pressed': active ? 'true' : 'false',
  },
    h('span', { class: 'lib-chip-label' }, label),
    count !== undefined ? h('span', { class: 'lib-chip-count' }, String(count)) : null,
  );
  if (onClick) on(el, 'click', onClick);
  return el;
}
